import React, {Component} from 'react';
import {getEquipmentViewFormFieldsByUserId,getFetchUrlParams} from '../../util/APIUtils';
import {SESSION_USER} from '../../constants';
import Loading from '../../common/Loading';
import NotFound from '../../common/NotFound';

//import Calendar from './../schedule/Calendar';
import EquipmentCalendar from './EquipmentCalendar';


import External from './../schedule/External';
import ServerError from '../../common/ServerError';
//import UnScheduleJobForm from './UnScheduleJobForm';

class EquipmentView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resources:[],
            fields:[],
            nowdatetime:'',
            currenttime:'',
            loading: true,
            scheduleloading: true,
            ssoparams:'',
            fieldsloading:true,
            calendarview:'timelineDay',
            travelEventBgColor:'#54555e'
        };
            
    }



    componentDidMount() {
   
   var params2 = getFetchUrlParams(this.props.location.search);
  // console.log(params2);
   if(params2.view){
          this.setState({calendarview:params2.view});
   }

   
                let user = JSON.parse(localStorage.getItem(SESSION_USER));
                if(user.setting){
                     this.setState({travelEventBgColor:user.setting.travelEventBgColor});
                }

                var peopleObject=[];
        
                getEquipmentViewFormFieldsByUserId(user.id).then(response => {
                     //   console.log(response);
                       if(response){ 
                        //console.log(response);
                             if(response.equipments){//here get all resouses in
                                   for(var k in response.equipments){
                                       var equipment=response.equipments[k];
                                      
                                      
                                       var image_url='../static/assets/images/equipment.png';
                                       

                                       var businessHours={dow: [ 1, 2, 3, 4,5,6,0 ],start:user.setting.fromtime,end:user.setting.totime};

                                       var resource={
                                            id:equipment.id,
                                            title:equipment.name,
                                            eventBackgroundColor:'',
                                            eventBorderColor:'',
                                            eventTextColor:'',
                                            image_url:image_url,
                                            businessHours:businessHours

                                       };
                                       peopleObject.push(resource);
                                   }
                                   this.setState({resources:peopleObject});
                            }
                            if(response.nowDateTime){
                              this.setState({nowdatetime:response.nowDateTime});
                            }
                             if(response.currentTime){
                              this.setState({currenttime:response.currentTime});
                            }
                            if(response.unschedules){
                                   this.setState({unschedule:response.unschedules});
                            }
                            if(response.schedules){
                                   this.setState({schedules:response.schedules});
                            }
                            this.setState({fields:response,fieldsloading: false});
                        }     
                      
                }).catch(error => {
                   if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });
         
         
              

    }

//<UnScheduleJobForm ssoparams={this.state.ssoparams}/>
    render(){

         if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

        if(this.state.fieldsloading) {
           return <Loading />;
        } 

    return (


                <div className="row">
                     
                    <External unschedule={this.state.unschedule}  />
                    <EquipmentCalendar calendarview={this.state.calendarview} currenttime={this.state.currenttime} nowdatetime ={this.state.nowdatetime} schedules={this.state.schedules} travelEventBgColor={this.state.travelEventBgColor} resources={this.state.resources} fields={this.state.fields}/>  
                </div>


          );
  } 
}
export default EquipmentView;